import { FingerprintPlugin } from '@fingerprint/vue'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(nuxtApp => {
    const fingerprintApiKey = nuxtApp.$config.public.fingerprint.apiKey

    // Fingerprint requires a browser API key before installing, so keep local
    // environments without the key from failing during app startup.
    if (!fingerprintApiKey) return

    nuxtApp.vueApp.use(FingerprintPlugin, {
        apiKey: fingerprintApiKey
    })
})
